/**
 * Number of days after which an order in "awaiting" status is considered overdue.
 * Used to highlight orders that have been waiting for customer pickup too long.
 *
 * Business rule: Orders awaiting pickup for 3+ days should be visually highlighted
 * to prompt operators to follow up with customers.
 */
export const AWAITING_OVERDUE_THRESHOLD_DAYS = 3;
